import diff from "../diff";

const serializeAgentProductDeal = (data) => data;
const serializeAgentDealPricing = (data) => ({
  id: data.id,
  price_relative_percentage: data.price_relative_percentage,
  price_relative_amount: data.price_relative_amount && data.price_relative_amount.value,
  price_absolute_amount: data.price_absolute_amount && data.price_absolute_amount.value,
  price_absolute_amount_currency: data.price_absolute_amount && data.price_absolute_amount.currency,
  commision_absolute_percentage: data.commision_absolute_percentage,
  commision_absolute_amount: data.commision_absolute_amount && data.commision_absolute_amount.value,
  commision_absolute_amount_currency: data.commision_absolute_amount && data.commision_absolute_amount.currency,
  commision_includes_product_options_amount: data.commision_includes_product_options_amount,
  service_fee_absolute_percentage: data.service_fee_absolute_percentage,
  service_fee_absolute_amount: data.service_fee_absolute_amount && data.service_fee_absolute_amount.value,
  service_fee_absolute_amount_currency: data.service_fee_absolute_amount && data.service_fee_absolute_amount.currency,
  service_fee_includes_product_options_amount: data.service_fee_includes_product_options_amount,
});

export default function serializeAgentCooperation(data, initialData) {
  return {
    ...data,
    agent_product_deals_attributes:
      data.agent_product_deals && data.agent_product_deals.map((x) => serializeAgentProductDeal(x)),
    agent_product_deals: undefined,
    agent_deal_pricings_attributes:
      data.agent_deal_pricings && data.agent_deal_pricings.map((x) => serializeAgentDealPricing(x)),
    agent_deal_pricings: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeAgentCooperation.js